/* Signature Customs — V4 "Will It Fit My Truck?" fit finder logic.
   Flow: type truck -> (rails? if unknown) -> bed cover? -> confirmed fit + 3/4-rod pick -> add to cart.
   railStatus: 'std' = factory rails all trims (Track direct); 'trim' = factory rails some trims (ask);
   'none' = no factory rails, aftermarket possible (ask about aftermarket, default Clamp). */
(function(){
  if(window.__scFitInit){ return; }
  window.__scFitInit = true;
  var root = document.querySelector('[data-sc-fit]');
  if(!root){ return; }
  var out = root.querySelector('[data-sc-fit-result]');
  var input = root.querySelector('[data-sc-fit-input]');
  var sugg = root.querySelector('[data-sc-fit-suggest]');
  var CHECK = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" fill="currentColor"/></svg>';
  var cur = {};
  // Per mount + rod count: single-set price, both-sides bundle price, and the bundle savings.
  var PRICES = {
    track:{ '3 Rods':{single:'$68',bundle:'$122.40',save:'$13.60'}, '4 Rods':{single:'$76.50',bundle:'$137.70',save:'$15.30'} },
    clamp:{ '3 Rods':{single:'$90.94',bundle:'$163.69',save:'$18.19'}, '4 Rods':{single:'$99.44',bundle:'$178.99',save:'$19.89'} }
  };
  function priceStr(){ var p = PRICES[cur.mount][cur.cap]; return cur.bundle ? p.bundle : p.single; }

  // [make, model, railStatus, railName, [aliases]]
  var VEHICLES = [
    ['Ford','F-150','none','',['f150']],
    ['Ford','F-250 Super Duty','none','',['f250','superduty']],
    ['Ford','F-350 Super Duty','none','',['f350']],
    ['Ford','F-450 Super Duty','none','',['f450']],
    ['Ford','Ranger','none','',[]],
    ['Ford','Maverick','none','',[]],
    ['Ford','F-150 Lightning','none','',['lightning','f150lightning']],
    ['Chevrolet','Silverado 1500','none','',['silverado','chevy1500']],
    ['Chevrolet','Silverado 2500HD','none','',['silverado2500','2500hd']],
    ['Chevrolet','Silverado 3500HD','none','',['silverado3500']],
    ['Chevrolet','Colorado','none','',[]],
    ['Chevrolet','Silverado EV','none','',['silveradoev']],
    ['GMC','Sierra 1500','none','',['sierra']],
    ['GMC','Sierra 2500HD','none','',['sierra2500']],
    ['GMC','Sierra 3500HD','none','',['sierra3500']],
    ['GMC','Canyon','none','',[]],
    ['GMC','Sierra EV','none','',['sierraev']],
    ['GMC','Hummer EV','none','',['hummer','hummerev']],
    ['RAM','1500','trim','the RamBox cargo rails',['ram1500','dodgeram']],
    ['RAM','1500 Classic','trim','the RamBox cargo rails',['ram1500classic']],
    ['RAM','2500','trim','the RamBox cargo rails',['ram2500']],
    ['RAM','3500','trim','the RamBox cargo rails',['ram3500']],
    ['Toyota','Tacoma','trim','the Toyota Deck Rail System',['taco']],
    ['Toyota','Tundra','trim','the Toyota Deck Rail System',[]],
    ['Nissan','Frontier','trim','Nissan Utili-track channels',[]],
    ['Nissan','Titan','trim','Nissan Utili-track channels',[]],
    ['Nissan','Titan XD','trim','Nissan Utili-track channels',['titanxd']],
    ['Jeep','Gladiator','trim','the Jeep Trail Rail system',['jt']],
    ['Honda','Ridgeline','none','',[]],
    ['Hyundai','Santa Cruz','none','',['santacruz']],
    ['Rivian','R1T','none','',['rivian']],
    ['Tesla','Cybertruck','std','factory L-track bed rails',['tesla','cyber']]
  ];
  function norm(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]/g,''); }
  VEHICLES.forEach(function(v){
    v.keys = [norm(v[0]), norm(v[1]), norm(v[0]+v[1])].concat((v[4]||[]).map(norm)).filter(function(k){ return k.length; });
  });

  // Select a variant option in the real buy box by matching its value text.
  function selectOption(needle){
    var done = false;
    document.querySelectorAll('input[type="radio"]').forEach(function(r){
      if((r.value || '').indexOf(needle) > -1){
        r.checked = true;
        var lbl = r.id ? document.querySelector('label[for="' + r.id + '"]') : null;
        if(lbl){ lbl.click(); } else { r.click(); }
        r.dispatchEvent(new Event('change', {bubbles:true}));
        done = true;
      }
    });
    if(!done){
      document.querySelectorAll('select').forEach(function(s){
        Array.prototype.forEach.call(s.options, function(o){
          if((o.value || '').indexOf(needle) > -1){ s.value = o.value; s.dispatchEvent(new Event('change', {bubbles:true})); done = true; }
        });
      });
    }
    if(!done){
      document.querySelectorAll('.variant__button-label, label').forEach(function(l){
        if(!done && l.textContent && l.textContent.indexOf(needle) > -1){ l.click(); done = true; }
      });
    }
    return done;
  }
  function selectMount(mount){ return selectOption(mount === 'track' ? 'Track Mount' : 'Clamp System'); }
  function selectCapacity(cap){ return selectOption(cap); }
  // Push the full current selection (mount + rod count + one/both sides) into the real buy box.
  function applyVariant(){
    selectMount(cur.mount);
    selectCapacity(cur.cap || '3 Rods');
    selectOption(cur.bundle ? '2 Sets' : '1 Set');
  }
  // Re-sync buy box + refresh the CTA price and bundle savings text after a toggle.
  function refreshPricing(){
    applyVariant();
    var ps = out.querySelector('[data-cap-price]');
    if(ps){ ps.textContent = priceStr(); }
    var bsub = out.querySelector('[data-bundle-sub]');
    if(bsub){ bsub.textContent = cur.bundle ? ('You save ' + PRICES[cur.mount][cur.cap].save) : 'Add the other side of your bed'; }
  }
  function addToCart(){
    applyVariant();
    setTimeout(function(){
      var b = document.querySelector('[data-add-to-cart]');
      if(b){ b.click(); }
    }, 140);
  }
  function show(){ out.hidden = false; out.scrollIntoView({behavior:'smooth', block:'nearest'}); }

  function start(name, subj, railStatus, railName){
    cur = { name:name, subj:subj, railStatus:railStatus, railName:railName };
    if(railStatus === 'std'){ cur.mount = 'track'; askCover(); }
    else { askRails(); }
  }
  function askRails(){
    var q, yes, no, hint;
    if(cur.railStatus === 'trim'){
      q = 'Does your ' + cur.subj + ' have ' + cur.railName + '?';
      yes = 'Yes, it has rails'; no = 'No rails / base trim';
      hint = 'Factory bed rails are the raised channels along the top of the bed walls (on higher trims). No rails? The Clamp System fits any bed.';
    } else {
      q = 'The ' + cur.subj + ' doesn’t come with factory bed rails. Have you added aftermarket bed rails?';
      yes = 'Yes, I added rails'; no = 'No / stock bed';
      hint = 'No rails? No problem — the Clamp System grips your bed walls directly and fits any bed.';
    }
    out.innerHTML =
      '<p class="sc-fit__ask">' + q + '</p>' +
      '<div class="sc-fit__askrow">' +
        '<button type="button" data-sc-rails="track">' + yes + '</button>' +
        '<button type="button" data-sc-rails="clamp">' + no + '</button>' +
      '</div>' +
      '<p class="sc-fit__hint">' + hint + '</p>';
    show();
  }
  function askCover(){
    out.innerHTML =
      '<p class="sc-fit__ask">Last thing — do you run a tonneau or bed cover?</p>' +
      '<div class="sc-fit__askrow">' +
        '<button type="button" data-sc-cover="yes">Yes, I have a cover</button>' +
        '<button type="button" data-sc-cover="no">No cover</button>' +
      '</div>';
    show();
  }
  function showFinal(){
    var mount = cur.mount;
    var isTrack = mount === 'track';
    var mountName = isTrack ? 'Track Mount' : 'Clamp System';
    var why;
    if(isTrack && cur.railStatus === 'std'){ why = 'Your ' + cur.name + '’s ' + cur.railName + ' let the Track Mount lock straight in — no drilling, rock-solid hold.'; }
    else if(isTrack){ why = 'Your bed rails let the Track Mount drop straight into the channel and lock down — no drilling, rock-solid hold.'; }
    else { why = 'The Clamp System’s heavy-duty brackets grip your bed walls directly — no drilling, and they adjust to fit any bed length.'; }
    var cover = (cur.cover === true)
      ? ' And since you run a bed cover: the V4 holds your rods low and flat, so your tonneau still closes over fully-rigged rods.'
      : ' Open bed: your rods stay locked low and rattle-free, with the floor clear for the rest of your gear.';
    cur.cap = '3 Rods';
    cur.bundle = false;
    applyVariant();
    out.innerHTML =
      '<p class="sc-fit__yes">' + CHECK + 'Yes — your ' + cur.name + ' is a confirmed fit.</p>' +
      '<p class="sc-fit__mount">You’ll use the <strong>' + mountName + '</strong>.</p>' +
      '<p class="sc-fit__why">' + why + cover + '</p>' +
      '<p class="sc-fit__caplabel">How many rods do you run?</p>' +
      '<div class="sc-fit__caprow">' +
        '<button type="button" class="sc-fit__cap is-sel" data-cap="3 Rods">3 Rods<small>' + PRICES[mount]['3 Rods'].single + '</small></button>' +
        '<button type="button" class="sc-fit__cap" data-cap="4 Rods">4 Rods<small>' + PRICES[mount]['4 Rods'].single + '</small></button>' +
      '</div>' +
      '<button type="button" class="sc-fit__bundle" data-bundle>' +
        '<span class="sc-fit__bundle-main">Bundle &amp; Save — Both Sides</span>' +
        '<span class="sc-fit__bundle-sub" data-bundle-sub>Add the other side of your bed</span>' +
      '</button>' +
      '<button type="button" class="sc-fit__cta" data-sc-add>Add to Cart · <span data-cap-price>' + PRICES[mount]['3 Rods'].single + '</span> →</button>' +
      '<p class="sc-fit__hint" style="text-align:center;">Free shipping · ships in 3–5 days</p>';
    show();
  }

  // ---- type-ahead search ----
  function yearOf(q){ var m = q.match(/\b(19|20)\d{2}\b/); return m ? m[0] : ''; }
  function search(q){
    var qn = norm(q.replace(/\b(19|20)\d{2}\b/g, ''));
    if(qn.length < 1){ return []; }
    var scored = [];
    VEHICLES.forEach(function(v){
      var best = 0;
      v.keys.forEach(function(k){
        if(k.indexOf(qn) === 0){ best = Math.max(best, 3); }
        else if(k.indexOf(qn) > -1){ best = Math.max(best, 2); }
        else if(qn.length >= 3 && qn.indexOf(k) > -1 && k.length >= 3){ best = Math.max(best, 1); }
      });
      if(best > 0){ scored.push([best, v]); }
    });
    scored.sort(function(a,b){ return b[0]-a[0] || (a[1][0]+a[1][1]).localeCompare(b[1][0]+b[1][1]); });
    return scored.slice(0,6).map(function(s){ return s[1]; });
  }
  function resolveVehicle(v){
    var year = yearOf(input.value);
    var name = (year ? year + ' ' : '') + v[0] + ' ' + v[1];
    hideSugg();
    input.value = name;
    start(name, v[0] + ' ' + v[1], v[2], v[3]);
  }
  function hideSugg(){ sugg.hidden = true; sugg.innerHTML = ''; sugg._list = null; }
  function renderSugg(list){
    if(!list.length){
      sugg.innerHTML = '<li data-sc-nomatch><span class="sc-fit__sg-ask">Don’t see your truck? Check by bed rails →</span></li>';
      sugg.hidden = false; return;
    }
    sugg.innerHTML = list.map(function(v, i){
      return '<li data-sc-pick="' + i + '"><span>' + v[1] + '</span><span class="sc-fit__sg-make">' + v[0] + '</span></li>';
    }).join('');
    sugg._list = list;
    sugg.hidden = false;
  }
  var t;
  input.addEventListener('input', function(){
    clearTimeout(t);
    t = setTimeout(function(){ renderSugg(search(input.value)); }, 60);
  });
  input.addEventListener('focus', function(){ if(input.value.trim().length){ renderSugg(search(input.value)); } });
  input.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){
      e.preventDefault();
      if(sugg._list && sugg._list.length){ resolveVehicle(sugg._list[0]); }
      else { hideSugg(); start('your truck', 'your truck', 'none', ''); }
    } else if(e.key === 'Escape'){ hideSugg(); }
  });
  sugg.addEventListener('click', function(e){
    var pick = e.target.closest('[data-sc-pick]');
    if(pick){ resolveVehicle(sugg._list[+pick.getAttribute('data-sc-pick')]); return; }
    if(e.target.closest('[data-sc-nomatch]')){ hideSugg(); start('your truck', 'your truck', 'none', ''); }
  });
  document.addEventListener('click', function(e){
    if(!root.querySelector('.sc-fit__search').contains(e.target)){ hideSugg(); }
  });

  // ---- result delegation ----
  out.addEventListener('click', function(e){
    var rails = e.target.closest('[data-sc-rails]');
    if(rails){ cur.mount = rails.getAttribute('data-sc-rails'); askCover(); return; }
    var cover = e.target.closest('[data-sc-cover]');
    if(cover){ cur.cover = (cover.getAttribute('data-sc-cover') === 'yes'); showFinal(); return; }
    var cap = e.target.closest('[data-cap]');
    if(cap){
      cur.cap = cap.getAttribute('data-cap');
      out.querySelectorAll('[data-cap]').forEach(function(b){ b.classList.toggle('is-sel', b === cap); });
      refreshPricing();
      return;
    }
    var bundle = e.target.closest('[data-bundle]');
    if(bundle){
      cur.bundle = !cur.bundle;
      bundle.classList.toggle('is-sel', cur.bundle);
      refreshPricing();
      return;
    }
    var add = e.target.closest('[data-sc-add]');
    if(add){ addToCart(); }
  });

  // ---- "Vehicle Compatibility" dropdown -> jump up to this fit finder ----
  document.addEventListener('click', function(e){
    var trig = e.target.closest('.collapsible-trigger, summary, button, a');
    if(!trig){ return; }
    if((trig.textContent || '').toLowerCase().indexOf('vehicle compatibility') === -1){ return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    trig.classList.add('sc-jumping');
    setTimeout(function(){ trig.classList.remove('sc-jumping'); }, 900);
    // scrollIntoView auto-detects the real scroll container (this theme doesn't scroll window/document).
    // Try smooth first, then fall back to instant a beat later if the page hasn't moved (some in-app browsers no-op smooth).
    var beforeTop = root.getBoundingClientRect().top;
    try { root.scrollIntoView({behavior:'smooth', block:'center'}); } catch(_) { root.scrollIntoView(); }
    setTimeout(function(){
      var t = root.getBoundingClientRect().top;
      if(Math.abs(t - beforeTop) < 4){ root.scrollIntoView({block:'center'}); }
    }, 260);
    root.classList.remove('sc-fit--flash');
    void root.offsetWidth;
    root.classList.add('sc-fit--flash');
    setTimeout(function(){ root.classList.remove('sc-fit--flash'); }, 1700);
    if(input){ setTimeout(function(){ try{ input.focus({preventScroll:true}); }catch(_){} }, 650); }
  }, true);
})();
